export const getCompositeKey = <T>(cons: Partial<T>) => {
  return hashInt(JSON.stringify(cons));
};

const hashInt = (str: string, max = 100000000) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash = hash & hash;
  }
  return Math.round((max * Math.abs(hash)) / 2147483648);
};
